import React from "react";

import { Descriptions, Button, Row, Col, Statistic, Card, Tag } from "antd";
import { APP_VERSION } from "../../../../config/const";

import { CheckCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

export default class Information extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
        };
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _reload = () => {
        window.location.reload(true);
    };

    render() {
        const { data } = this.props;

        const newVersion = data.version != APP_VERSION;

        return (
            <>
                <div className="site-card-wrapper">
                    <Row gutter={24}>
                        <Col span={12}>
                            <Card
                                title="System Information"
                                bordered={false}
                                extra={[
                                    <Button
                                        key="1"
                                        size="small"
                                        style={{ marginTop: 16 }}
                                        type="primary"
                                        onClick={this._reload}
                                    >
                                        Update App
                                    </Button>,
                                ]}
                            >
                                <Row gutter={24} justify="space-around" align="middle">
                                    <Col span={12}>
                                        <Statistic title="Version" value={APP_VERSION} />
                                    </Col>
                                    <Col span={12} align="right">
                                        {newVersion ? (
                                            <Tag icon={<ExclamationCircleOutlined />} color="warning">
                                                New version!
                                            </Tag>
                                        ) : (
                                            <Tag icon={<CheckCircleOutlined />} color="success">
                                                Updated!
                                            </Tag>
                                        )}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        {this.state.hidden && (
                            <Col span={12}>
                                <Card
                                    title="User Information"
                                    bordered={false}
                                    extra={[
                                        <Button size="small" style={{ marginTop: 16 }} type="primary">
                                            Change Password
                                        </Button>,
                                    ]}
                                >
                                    <Descriptions column={2}>
                                        <Descriptions.Item label="User Name">
                                            {data.user ? data.user.username : ""}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Role"></Descriptions.Item>
                                        <Descriptions.Item label="Fist Name"></Descriptions.Item>
                                        <Descriptions.Item label="Last Name"></Descriptions.Item>
                                    </Descriptions>
                                </Card>
                            </Col>
                        )}
                    </Row>
                </div>
            </>
        );
    }
}
